import {
	Directive,
	Input,
	OnDestroy,
	TemplateRef,
	ViewContainerRef
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SubscriptionLike } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export class MatError {
	ctrl: AbstractControl;
	err: string;
}

@Directive({
	selector: '[n9MatErrors]'
})
export class MatErrorsDirective implements OnDestroy {
	protected defaultError: string = 'common.form.errors.';
	protected error: string = null;

	@Input()
	set n9MatErrors(matError: MatError) {
		this.error = matError.err;
		this.subscription = matError.ctrl.statusChanges.subscribe(() =>
			this.checkValidity(matError.ctrl)
		);
	}

	protected subscription: SubscriptionLike;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private translationService: TranslateService
	) {}

	public checkValidity(control: AbstractControl): void {
		this.viewContainer.clear();
		if (control.invalid)
			Object.keys(control.errors).map(error =>
				this.createView(error, control.errors[error])
			);
	}

	public createView(error: string, params?: object): void {
		this.viewContainer.createEmbeddedView(this.templateRef, {
			$implicit: this.getInstant(error, params)
		});
	}

	public getInstant(error: string, params?: object): string | any {
		if (error && error.startsWith('matDatepicker')) return ''; // toDo:: Remove this and handle datepicker min/max error here
		let instant = this.translationService.instant(
			this.error + error,
			params
		);
		if (params[error] && !isNaN(params[error]))
			params[error] = params[error]
				.toLocaleString('en-GB')
				.replace(/\,/g, '.');
		if (!this.error || (this.error && instant.endsWith(error)))
			instant = this.translationService.instant(
				this.defaultError + error,
				params
			);
		return instant;
	}

	public ngOnDestroy(): void {
		if (this.subscription) this.subscription.unsubscribe();
	}
}
